export default "__VITE_PUBLIC_ASSET__df2fd194__"